import useFormFields from './useFormFields'
import useCrudAffiliation from './useCrudAffiliation'
import useTabs from './useTabs'
import useHeaderBtns from './useHeaderBtns'
import useGradesTableColumns from './useGradesTableColumns'
import useTestTakerTableColumns from './useTestTakerTableColumns'
import useClassHeaderBtns from './useClassHeaderBtns'
import useCreateClass from './useCreateClass'
import useDownloadStudentFileAlert from './useDownloadStudentFileAlert'
import useTeamTableColumns from './useTeamTableColumns'
import useUserTableColumns from './useUserTableColumns'
import useLearningGroupTableColumns from './useLearningGroupTableColumns'

export default { useLearningGroupTableColumns, useTeamTableColumns, useHeaderBtns, useUserTableColumns, useDownloadStudentFileAlert, useCreateClass, useClassHeaderBtns, useTabs, useTestTakerTableColumns, useFormFields, useGradesTableColumns, useCrudAffiliation }